import React, { useState } from 'react';

import Card from '../Card/Card';

function StatisticsCard(props: StatisticsCardProps) {

    const [loading, setLoading] = useState<boolean>(true);

    return (
        <Card
            title={props.title}
        >
            {props.children}
        </Card>
    );
}

class StatisticsCardProps {
    children!: any;
    title!: string;
}

export default StatisticsCard;